enum SignupUserStatus {
  Invited = "Invited",
  Registered = "Registered",
  Unsubscribed = "Unsubscribed",
}

export default SignupUserStatus;
